export default {
  'reports.title': 'Manage Reports',
  'reports.reportGroups': 'Report Groups',
  'reports.form.reportGroup': 'Report Group',
  'reports.form.reportId': 'PowerBI Report Id',
  'reports.form.datasetId': 'PowerBI Dataset Id',
  'reports.form.defaultReportSection': 'Default Report Section',
  'reports.form.isMultipage': 'Multiple Pages?',
  'reports.form.isReportDataFilterByUserEnabled': 'Report Data Filter by User?',
  'reports.form.isReportDataFilterByPositionEnabled': 'Report Data Filter by Position?',
  'reports.form.reportDataFilterUserTableName': 'Table Name for User Filter',
  'reports.form.reportDataFilterUserFieldName': 'Field Name for User Filter',
  'reports.form.reportDataFilterUserFieldNameInternal': 'Internal Field Name for User Filter',
  'reports.form.reportDataFilterPositionTableName': 'Table Name for Position Filter',
  'reports.form.reportDataFilterPositionFieldName': 'Field Name for Position Filter',
  'reports.form.reportDataFilterPositionFieldNameInternal':
    'Internal Field Name for Position Filter',
  'reports.form.isReportDataFilterByAreaEnabled': 'Report Data Filter by Area?',
  'reports.form.reportDataFilterAreaTableName': 'Table Name for Area Filter',
  'reports.form.reportDataFilterAreaFieldName': 'Field Name for Area Filter',
  'reports.form.reportDataFilterAreaFieldNameInternal': 'Internal Field Name for Area Filter',
  'reports.form.isReportDataFilterByDynamicEntityEnabled': 'Report Data Filter by Dynamic Entity?',
  'reports.form.reportDataFilterDynamicEntityTableName': 'Table Name for Dynamic Entity Filter',
  'reports.form.reportDataFilterDynamicEntityFieldName': 'Field Name for Dynamic Entity Filter',
  'reports.form.reportDataFilterDynamicEntityId': 'Dynamic Entity',
  'reports.form.reportDataFilterDynamicEntityFieldUserFieldId': 'Dynamic Entity / User Field',
  'reports.form.reportDataFilterDynamicEntityFieldDataFieldId': 'Dynamic Entity / Filter Field',
  'reports.form.isReportDataFilterByUserGroupsEnabled': 'Report Data Filter by User Groups?',
  'reports.form.reportDataFilterUserGroupTableName': 'Table Name for User Group Filter',
  'reports.form.reportDataFilterUserGroupFieldName': 'Field Name for User Group Filter',
  'reports.form.reportDataFilterUserGroupFieldNameInternal':
    'Internal Field Name for User Group Filter',
  'reports.type.administration': 'Administration',
  'reports.type.process': 'Process',
  'reports.type.request': 'Request',
  'reports.type.generic': 'Generic',
  'reports.platform.web': 'Web',
  'reports.platform.mobile': 'Mobile',
  'reports.platform.webMobile': 'Web and Mobile',
  'reports.logicalOperator.or': 'Or',
  'reports.logicalOperator.and': 'And',
  'reports.permissionsFiltersLogicalOperator': 'Logical Operator Permissions',
};
